module.exports = function() {
  return new Worker(__webpack_public_path__ + "615df010276f93ab814f.worker.js");
};